import { useSessionStorage } from '@mantine/hooks';

// A session-storage hook to store the value of 'fbl-activate-now' in session storage
type Active = 'true' | 'false';

/**
 * Activate now is more polished term for "skipping the trial and activating the plan straight away"
 * We don't want to say anywhere on the UI that we are skipping
 * the trial as internal only flow to take the users straight into full version.
 */

function useFBLActivate() {
  const [value, setValue, removeValue] = useSessionStorage<Active>({
    key: 'fbl-activate',
    defaultValue: 'false',
  });

  return { value, setValue, removeValue };
}

export { useFBLActivate };
